export function getSymbolName(symbol: {
  instrumentName?: string | null;
  name?: string | null;
  instrumentTitle?: string | null;
}): string {
  return symbol.instrumentName || symbol.instrumentTitle || symbol.name || '';
}
